
import { computed, defineComponent, onMounted, reactive, watch } from "vue";
import config from "@/config";
import { useI18n } from "vue-i18n";
import { location } from "@/utils/default-data";
import { selectedLocale, Language } from "@/locales/i18n";
export default defineComponent({
  props: {
    data: {
      type: Object,
    },
    display: {
      type: Array,
      default: () => ["image", "title", "description", "infoList", "location"],
    },
    display_left: {
      type: Array,
      default: () => ["title", "description", "accordion", "linkList"],
    },
    compact: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const state = reactive({
      image: null,
      locationData: {
        lat: location.lat,
        lng: location.lng,
      },
      imagePath: require("@/assets/images/slide-2.jpg"),
      imageDefaultPath: "@/assets/images/product-thumb-sm.png",
    });

    onMounted(() => {
      setPreviewLocation();
      setPreviewImage();
    });

    const displayContains = (el: any) => {
      return props.display.indexOf(el) > -1;
    };

    const displayLeftContains = (el: any) => {
      return props.display_left.indexOf(el) > -1;
    };

    watch(
      () => props.data?.id,
      () => {
        setPreviewImage();
        setPreviewLocation();
      }
    );

    function setPreviewLocation() {
      state.locationData = {
        lat: props.data?.location.latitude || location.lat,
        lng: props.data?.location.longitude || location.lng,
      } as any;
    }

    function setPreviewImage() {
      state.imagePath = require("@/assets/images/slide-2.jpg");
      if (props.data?.images.length > 0) {
        const imageId = props.data?.images[0].id;
        state.imagePath = `"${config.briumApiBaseUrl}/api/v1/ResearchEquipment/${props.data?.id}/image/${imageId}"`;
      }
    }

    return {
      t,
      state,
      displayContains,
      displayLeftContains,
      defaultLanguageSelected: computed(() => selectedLocale() === Language.sl),
    };
  },
});
